
<ManuallyExpandableImagePreview
    :image="image"
    :filter="filter"
    small-height="128px"
    :small-width="landscape ? '188px' : null"
    ref="imagePreview"
    class="previewContainer"
    :class="{selected: selected}"
    @select="onSelect"
/>
